import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FirstVisitHintService } from '../../services/first-visit-hint.service';

@Component({
  selector: 'app-first-visit-hint',
  templateUrl: './first-visit-hint.component.html',
  styleUrls: ['./first-visit-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule],
})
export class FirstVisitHintComponent {
  private readonly firstVisitHint = inject(FirstVisitHintService);

  readonly hintId = input.required<string>();
  readonly titleKey = input.required<string>();
  readonly descriptionKey = input<string>();
  readonly arrowLeft = input('1.75rem');
  readonly alignEnd = input(false);

  dismiss(): void {
    this.firstVisitHint.dismissHint(this.hintId());
  }

  onGotItPointerDown(event: Event): void {
    event.stopPropagation();
  }

  onGotItClick(event: Event): void {
    event.stopPropagation();
    this.dismiss();
  }
}
